<script>
import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";
import Modal from "@/components/Modal";
import ProjectService from "@/services/ProjectService";
import ProjectStageService from "@/services/ProjectStageService";
import VStageProgress from "@/views/ProjectsPlanning/components/VStageProgress";

export default {
    components: {
        DropzoneFileUpload,
        Modal,
        VStageProgress
    },
    props: {
        project_id: {}
    },
    data() {
        return {
            loading: false,
            mainImage: null,
            layoutImage: null,
            projectDescription: "",
            projectDescriptionEdit: "",
            showImageModal: false,
            selectedImageForModal: null,
            dropzoneOptions: {
                acceptedFiles: "image/*",
                autoProcessQueue: false
            },
            editModeMain: false,
            editModeText: false,
            editModeLayout: false,
            projectStages: []
        };
    },
    async created() {
        await this.fetchData();
        await this.fetchBoardStatus();
    },
    computed: {
        formattedDescription() {
            if (!this.projectDescription) {
                return this.$t("project.project_start_description_placeholder");
            }
            return this.projectDescription.replace(/\n/g, "<br>");
        },
        descriptionCharsRemaining() {
            const max = 1100;
            const current = this.projectDescriptionEdit
                ? this.projectDescriptionEdit.length
                : 0;
            return max - current;
        }
    },
    methods: {
        async fetchBoardStatus() {
            try {
                const { data } = await ProjectStageService.GET_boardStatus(
                    this.project_id
                );
                this.projectStages = data.data;
            } catch (e) {
                console.log("boardStatus e", e);
            }
        },
        /**
         * <img
            style="width: 100%; height: auto;"
            :src="`data:image/png;base64,${b64}`"
            :alt="filename"

         */
        async fetchData() {
            try {
                const { data } = await ProjectService.GET_introData(
                    this.project_id
                );
                if (data.data.intro_img_main !== null) {
                    this.mainImage = `data:image/png;base64,${data.data.intro_img_main}`;
                }

                if (data.data.intro_img_layout !== null) {
                    this.layoutImage = `data:image/png;base64,${data.data.intro_img_layout}`;
                }

                this.projectDescription = data.data.intro_text;
            } catch (e) {
                console.log("fetchData e", e);
            }
        },
        async uploadImage(file, imageType) {
            const formData = new FormData();
            formData.append("image", file);
            formData.append("image_type", imageType);

            try {
                this.loading = true;
                await ProjectService.POST_startImage(this.project_id, formData);

                const reader = new FileReader();
                reader.onload = e => {
                    if (imageType === "main") {
                        this.mainImage = e.target.result;
                        this.editModeMain = false;
                    } else {
                        this.layoutImage = e.target.result;
                        this.editModeLayout = false;
                    }
                };
                reader.readAsDataURL(file);

                this.$notify({
                    message: this.$t("project.image_uploaded_successfully"),
                    type: "success"
                });
            } catch (e) {
                console.error("Upload error:", e);
                this.$notify({
                    message: this.$t("project.image_upload_failed"),
                    type: "danger"
                });
            } finally {
                this.loading = false;
            }
        },
        onMainImageAdded(file) {
            if (file) {
                this.uploadImage(file, "main");
            }
        },
        onLayoutImageAdded(file) {
            if (file) {
                this.uploadImage(file, "layout");
            }
        },
        openImageModal(imageSrc) {
            this.selectedImageForModal = imageSrc;
            this.showImageModal = true;
        },
        closeImageModal() {
            this.showImageModal = false;
            this.selectedImageForModal = null;
        },
        toggleEditMain() {
            this.editModeMain = !this.editModeMain;
        },
        async deleteMainImage() {
            try {
                this.loading = true;
                await ProjectService.DELETE_startImage(this.project_id, "main");
                this.mainImage = null;
                this.editModeMain = false;

                this.$notify({
                    message: this.$t("project.image_deleted_successfully"),
                    type: "success"
                });
                this.fetchData();
            } catch (e) {
                console.error("Delete error:", e);
                this.$notify({
                    message: this.$t("project.image_delete_failed"),
                    type: "danger"
                });
            } finally {
                this.loading = false;
            }
        },
        toggleEditLayout() {
            this.editModeLayout = !this.editModeLayout;
        },
        async deleteLayoutImage() {
            try {
                this.loading = true;
                await ProjectService.DELETE_startImage(
                    this.project_id,
                    "layout"
                );
                this.layoutImage = null;
                this.editModeLayout = false;

                this.$notify({
                    message: this.$t("project.image_deleted_successfully"),
                    type: "success"
                });
            } catch (e) {
                console.error("Delete error:", e);
                this.$notify({
                    message: this.$t("project.image_delete_failed"),
                    type: "danger"
                });
            } finally {
                this.loading = false;
            }
        },
        toggleEditText() {
            if (!this.editModeText) {
                this.projectDescriptionEdit = this.projectDescription;
            }
            this.editModeText = !this.editModeText;
        },
        async saveText() {
            try {
                this.loading = true;
                await ProjectService.PUT_startDescription(this.project_id, {
                    description: this.projectDescriptionEdit
                });

                this.projectDescription = this.projectDescriptionEdit;
                this.editModeText = false;

                this.$notify({
                    message: this.$t("project.description_saved_successfully"),
                    type: "success"
                });
            } catch (e) {
                console.error("Save error:", e);
                this.$notify({
                    message: this.$t("project.description_save_failed"),
                    type: "danger"
                });
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<template>
    <div>
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <v-stage-progress class="mt-4" :stages="projectStages" />

                    <div class="text-right" style="font-size: 12px;">
                        <router-link
                            class="text-default"
                            :to="{
                                name: 'ProjectPlanningMilestones',
                                params: { project_id }
                            }"
                            >{{ $t("projects.see_milestones") }}</router-link
                        >
                    </div>

                    <div class="start-layout mt-4" v-if="true">
                        <!-- Left side: Main image upload (50% width, 2 proportions height) -->
                        <div class="start-layout__left">
                            <div class="box-container">
                                <div class="box-header">
                                    <div class="box-actions">
                                        <base-button
                                            v-if="mainImage && editModeMain"
                                            type="danger"
                                            outline
                                            @click="deleteMainImage"
                                        >
                                            <i class="fas fa-trash"></i>
                                        </base-button>
                                        <base-button
                                            v-if="mainImage"
                                            type="primary"
                                            outline
                                            @click="toggleEditMain"
                                        >
                                            <i class="fas fa-pencil-alt"></i>
                                        </base-button>
                                    </div>
                                </div>
                                <div class="image-upload-container">
                                    <template v-if="mainImage && !editModeMain">
                                        <img
                                            :src="mainImage"
                                            alt="Main project image"
                                            class="main-image"
                                            @click="openImageModal(mainImage)"
                                        />
                                    </template>
                                    <template v-else>
                                        <dropzone-file-upload
                                            url="/"
                                            :multiple="false"
                                            :options="dropzoneOptions"
                                            @addedfile="onMainImageAdded"
                                        />
                                    </template>
                                </div>
                            </div>
                        </div>

                        <!-- Right side: Text widget and document upload -->
                        <div class="start-layout__right">
                            <!-- Top: Text widget (1 proportion height) -->
                            <div class="start-layout__text">
                                <div class="box-container">
                                    <div class="box-header">
                                        <div class="box-actions">
                                            <span
                                                v-if="editModeText"
                                                class="char-counter"
                                                :class="{
                                                    'text-danger':
                                                        descriptionCharsRemaining <
                                                        0
                                                }"
                                            >
                                                {{ descriptionCharsRemaining }}
                                            </span>
                                            <base-button
                                                v-if="editModeText"
                                                type="primary"
                                                @click="saveText"
                                            >
                                                <i class="fas fa-check"></i>
                                            </base-button>
                                            <base-button
                                                type="primary"
                                                outline
                                                @click="toggleEditText"
                                            >
                                                <i
                                                    class="fas fa-pencil-alt"
                                                ></i>
                                            </base-button>
                                        </div>
                                    </div>
                                    <div class="text-content">
                                        <template v-if="editModeText">
                                            <textarea
                                                v-model="projectDescriptionEdit"
                                                class="form-control"
                                                :placeholder="
                                                    $t(
                                                        'project.project_start_description_placeholder'
                                                    )
                                                "
                                                rows="5"
                                                maxlength="1100"
                                            ></textarea>
                                        </template>
                                        <template v-else>
                                            <div
                                                class="text-display"
                                                :class="{
                                                    'text-warning': !projectDescription
                                                }"
                                                v-html="formattedDescription"
                                            ></div>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <!-- Bottom: Layout image upload (1 proportion height) -->
                            <div class="start-layout__layout">
                                <div class="box-container">
                                    <div class="box-header">
                                        <div class="box-actions">
                                            <button
                                                v-if="
                                                    layoutImage &&
                                                        editModeLayout
                                                "
                                                class="btn btn-sm btn-danger"
                                                @click="deleteLayoutImage"
                                            >
                                                <i class="fas fa-trash"></i>
                                            </button>
                                            <base-button
                                                v-if="layoutImage"
                                                @click="toggleEditLayout"
                                            >
                                                <i
                                                    class="fas fa-pencil-alt"
                                                ></i>
                                            </base-button>
                                        </div>
                                    </div>
                                    <div class="image-upload-container">
                                        <template
                                            v-if="
                                                layoutImage && !editModeLayout
                                            "
                                        >
                                            <img
                                                :src="layoutImage"
                                                alt="Layout image"
                                                class="layout-image"
                                                @click="
                                                    openImageModal(layoutImage)
                                                "
                                            />
                                        </template>
                                        <template v-else>
                                            <dropzone-file-upload
                                                url="/"
                                                :multiple="false"
                                                :options="dropzoneOptions"
                                                @addedfile="onLayoutImageAdded"
                                            />
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Image Modal -->
        <portal to="modals">
            <modal
                v-if="showImageModal"
                :show="true"
                @close="closeImageModal"
                size="full"
            >
                <template slot="header">
                    <h3>{{ $t("project.full_image") }}</h3>
                </template>
                <template slot="default">
                    <div class="text-center">
                        <img
                            v-if="selectedImageForModal"
                            :src="selectedImageForModal"
                            style="max-width: 100%; height: auto;"
                            alt="Full resolution image"
                        />
                    </div>
                </template>
            </modal>
        </portal>
    </div>
</template>

<style lang="scss">
.start-layout {
    min-height: 1200px;
    display: flex;
    gap: 20px;

    &__left {
        flex: 1.1;
        display: flex;
        flex-direction: column;
        height: 820px;
    }

    &__right {
        flex: 0.8;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    &__text {
        height: 400px;
        display: flex;
        flex-direction: column;
    }

    &__layout {
        height: 400px;
        display: flex;
        flex-direction: column;
    }
}

.box-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    border: 1px solid $gray-300;
    border-radius: 8px;
    background-color: white;

    .box-header {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 8px 12px;
        background-color: white;
        min-height: 36px;

        .box-actions {
            display: flex;
            align-items: center;
            gap: 5px;

            .char-counter {
                font-size: 12px;
                color: $gray-600;
                margin-right: 5px;
            }

            .btn {
                padding: 4px 8px;
                font-size: 12px;
            }
        }
    }

    .image-upload-container {
        flex: 1;
        display: flex;
        align-items: stretch;
        justify-content: center;
        background-color: white;
        overflow: hidden;
        height: calc(100% - 36px);

        .main-image,
        .layout-image {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            cursor: pointer;
            transition: opacity 0.3s;

            &:hover {
                opacity: 0.9;
            }
        }

        .dropzone {
            width: 100%;
            height: 100%;
            min-height: 100%;
            margin-bottom: 0 !important;
            display: flex;
            align-items: stretch;
            justify-content: center;
            border: none;
            background-color: white;

            .dz-message {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 1rem;
                margin: 14px;
            }
        }
    }

    .text-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 15px;
        overflow: hidden;

        textarea {
            flex: 1;
            resize: none;
            border: 1px solid $gray-300;
            overflow-y: auto;
        }

        .text-display {
            flex: 1;
            padding: 0px 10px 10px 10px;
            background-color: white;
            font-size: 14px;
            line-height: 1.5;
            word-wrap: break-word;
            overflow-y: auto;
        }
    }
}
</style>
